import { Field } from 'scripts/type'

export default function getFreshCurrentlyDisplayFieldsByTriggeredFields(
  displayFields: Field[][],
  targetCode: string,
  triggeredFields: Field[]
) {
  return displayFields.map((fields) => {
    const targetFieldIndex = fields.findIndex((field) => field.code === targetCode)
    if (targetFieldIndex > -1) {
      const withParentCodeTriggeredField = triggeredFields.map((field) => ({ ...field, parentCode: targetCode }))
      const targetFieldIsRootField = targetFieldIndex === 0
      if (targetFieldIsRootField) {
        return fields.slice(0, 1).concat(withParentCodeTriggeredField)
      }
      return fields
        .filter((field, fIdx) => {
          const isRootField = !field.parentCode
          const isDescendant = findPathStr(fields, targetCode).includes(field.code)
          return isRootField || fIdx <= targetFieldIndex || !isDescendant
        })
        .concat(withParentCodeTriggeredField)
    }
    return fields
  })
}

function findPathStr(fields: Field[], code: string) {
  const res = [code]
  fields.forEach((field) => {
    if (field.parentCode && res.includes(field.parentCode!)) {
      res.push(field.code)
    }
  })
  return res
}
